"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formartPrice = void 0;
const Currency_1 = __importDefault(require("helpers/Currency"));
const formartPrice = (price, currencyCode) => {
    return Currency_1.default.formatCurrencySymbol(price, currencyCode);
};
exports.formartPrice = formartPrice;
